export const HEADER_TEXT = "Are you sure you wish to submit your claim?";

export const PARAGRAPH_TEXT =
  "Once the claim is submitted, you will not be able to add any further information or details to the claim until the vendor has responded. The vendor will review the information within the claim form and any updates against this claim by the vendor will be provided via the messages or claims administration areas.";

export const SUBHEADER_TEXT =
  "Are there any other notes or messages you wish to send to the vendor?";
